<template>
  <el-dialog
    title="Notes"
    :visible.sync="isVisible"
    width="80vw"
    @closed="$emit('destroy')"
  >
    <Notes
      ref="notes"
      resource="ratecard"
      :identifier="rateCardId"
      :paginate="true"
      :limit="20"
    />
  </el-dialog>
</template>

<script>
import Notes from '@/components/Notes'

export default {
  components: {
    Notes
  },
  props: {
    rateCardId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      isVisible: true
    }
  }
}
</script>
